import {
    ableProps,
    ablePropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    ...ableProps,
    ...validatorProps,
    {
        key: 'align',
        label: '对齐位置',
        type: 'enum',
        collection: [
            {
                label: 'left',
                value: 'left',
            },
            {
                label: 'right',
                value: 'right',
            },
        ],
    },
    {
        key: 'text',
        label: '显示文字',
        type: 'string',
    },
    {
        key: 'linkText',
        label: '链接文字',
        type: 'string',
    },
    {
        key: 'linkHref',
        label: '链接地址',
        type: 'string',
    },
    {
        key: 'mustTrue',
        label: '必须勾选',
        type: 'boolean',
    },
    {
        key: 'errMustTrue',
        label: '未勾选提示文案',
        type: 'string',
    },
];

export const init = () => ({
    ...ablePropsInit,
    ...validatorPropsInit,
    align: 'left',
    text: '',
    linkText: '',
    linkHref: '',
    mustTrue: false,
    errMustTrue: '',
});

export const name = '勾选框';

export const component = 'mobile-general-form-checkbox';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];
